import { makeStyles } from "@material-ui/styles";

const useDrawerAccordionBaseStyles = makeStyles((theme) => ({
  accordion: {
    boxShadow: "none",
    "&:before": { display: "none" },
    "&.Mui-expanded": { margin: 0 },
  },
  accordionSummary: {
    backgroundColor: "#f0f0f0",
    minHeight: "unset",
    borderBottom: "1px solid #ddd",
    "&.Mui-expanded": { minHeight: "unset" },
    "& .MuiAccordionSummary-content": {
      margin: theme.spacing(1, 0),
      "&.Mui-expanded": { margin: theme.spacing(1, 0) },
    },
  },
  accordionSummaryText: {
    fontSize: 14,
    fontWeight: 500,
    color: "#333",
  },
  accordionDetails: {
    flexDirection: "column",
    padding: theme.spacing(1, 2),
  },
}));

export default useDrawerAccordionBaseStyles;
